// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"851eba00","592":"5c77253a"}[chunkId] + ".chunk.js";
};